import { defaultPotName } from "../constants";
import type { SpendingPot } from "../types";

export function validatePotName(name: string, spendingPots: SpendingPot[]) {
  const trimmedName = name.trim();

  if (trimmedName.length < 2) {
    return "Pot name must be at least 2 characters.";
  }

  if (trimmedName.length > 30) {
    return "Pot name must be 30 characters or fewer.";
  }

  if (trimmedName.toLocaleLowerCase() === defaultPotName.toLocaleLowerCase()) {
    return "Default is reserved for the automatically created pot.";
  }

  if (spendingPots.some((pot) => !pot.isArchived && pot.name.trim().toLocaleLowerCase() === trimmedName.toLocaleLowerCase())) {
    return "You already have a pot with that name.";
  }

  return null;
}
